import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=46acf55d&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=46acf55d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46acf55d",
  null
  
)

export default component.exports